import { FC } from 'react';
import styled from 'styled-components';
import { theme } from '../styles/GlobalStyles';
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF, BUSINESS_ID, ADDRESS } from '../constants/contact';

const FooterContainer = styled.footer`
  background-color: ${theme.primaryDark};
  color: ${theme.white};
  padding: 2rem 0;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
`;

const FooterLogo = styled.div`
  margin-bottom: 1.5rem;
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    margin-bottom: 0;
  }
  
  h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
    color: ${theme.white};
  }
  
  p {
    font-size: 0.9rem;
    margin: 0;
    color: rgba(255, 255, 255, 0.8);
  }
`;

const FooterLinks = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  @media (min-width: ${theme.breakpoints.tablet}) {
    flex-direction: row;
    align-items: flex-start;
  }

  > div {
    margin: 0 0 1.5rem 0;

    @media (min-width: ${theme.breakpoints.tablet}) {
      margin: 0 2rem 0 0;
    }
  }
  
  h4 {
    color: ${theme.white};
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      margin-bottom: 0.5rem;
      color: rgba(255, 255, 255, 0.8);
      
      a {
        color: rgba(255, 255, 255, 0.8);
        transition: color 0.3s ease;
        
        &:hover {
          color: ${theme.white};
        }

        &:focus-visible {
          outline-color: ${theme.white};
        }
      }
    }
  }
`;

const Copyright = styled.div`
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  text-align: center;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
  
  a {
    color: rgba(255, 255, 255, 0.8);
    
    &:hover {
      color: ${theme.white};
    }
  }
`;

const Keywords = styled.div`
  margin-top: 1.5rem;
  text-align: center;
  width: 100%;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.5);
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  
  span {
    margin: 0 0.5rem 0.5rem 0;
  }
`;

const Footer: FC = () => {
  const year = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>
          <h3>Ruhalan Murske</h3>
          <p>CE-merkitty tiilenpunainen graniittimurske Ruovedeltä</p>
        </FooterLogo>
        
        <FooterLinks>
          <div>
            <h4>Sivusto</h4>
            <ul>
              <li><a href="#tietoa">Tietoa murskeesta</a></li>
              <li><a href="#yhteystiedot">Yhteystiedot</a></li>
              <li><a href="#yhteystiedot">Tarjouspyyntö</a></li>
            </ul>
          </div>
          
          <div>
            <h4>Yhteystiedot</h4>
            <ul>
              <li>Puh: <a href={CONTACT_PHONE_HREF}>{CONTACT_PHONE}</a></li>
              <li><a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a></li>
              <li>{ADDRESS.full}</li>
              <li>Y-tunnus: {BUSINESS_ID}</li>
            </ul>
          </div>
          
          <div>
            <h4>Tuotevalikoimamme</h4>
            <ul>
              <li>KAM 0-8 mm (tasaus/pintakerros)</li>
              <li>KAM 0-16/22 mm (kantava kerros)</li>
              <li>KAM 0-32/56 mm (jakava kerros)</li>
              <li>KAM 0-90 mm (suodatinkerros)</li>
              <li>SEP 08-16/16-32 mm (salaojitus)</li>
            </ul>
          </div>
        </FooterLinks>
      </FooterContent>
      
      <Copyright>
        <p>&copy; {year} Ruhalan Murske. Kaikki oikeudet pidätetään.</p>
      </Copyright>
      
      <Keywords>
        <span>CE-merkitty murske</span>
        <span>Tiilenpunainen graniittimurske</span>
        <span>Murske Ruovesi</span>
        <span>Sepeli Pirkanmaa</span>
        <span>KAM murske</span>
        <span>Jakava kerros</span>
        <span>Kantava kerros</span>
        <span>Suodatinkerros</span>
        <span>Salaojitus</span>
        <span>Maa- ja tierakentaminen</span>
        <span>Betoni kiviaines</span>
        <span>Asfalttipäällysteet</span>
        <span>SFS-EN 13242</span>
      </Keywords>
    </FooterContainer>
  );
};

export default Footer; 